import { InputContext } from '../InputContext';
import { css } from '@emotion/css';
import { Typo } from '../../../ui/typo.ts';
import { Colors } from '../../../ui/vars';
import React from 'react';

interface Props {
    visible: boolean;
    text: React.ReactNode;
    context: InputContext;
}

export function Hint({ visible, text, context }: Props) {
    return (
        <div
            className={css([
                {
                    cursor: 'text',
                    ...Typo.body,
                    position: 'absolute',
                    bottom: '32px',
                    height: '16px',
                    width: '100%',
                },
                context === InputContext.regular && {
                    color: Colors.rgba(Colors.action_w, 0.4),
                },
                context === InputContext.form && {
                    color: Colors.rgba(Colors.action_f, 0.4),
                },
                context === InputContext.inverted && {
                    color: Colors.rgba(Colors.action_b, 0.4),
                },
                !visible && {
                    visibility: 'hidden',
                },
            ])}
        >
            {text}
        </div>
    );
}

export const Factory = (
    props: Props,
    ...children: React.ReactNode[]
): React.ReactElement => React.createElement(Hint, props, ...children);
